module.exports = __webpack_public_path__ + "img/lzd_lord_kroq_gar_0.40c361a7.png";